import { api_configuration } from "../../common";
import gui_definition_types = api_configuration.libraries.gui_definition_lib.types;
import api_client_state = api_configuration.types.client_state.alan_api;
import DestructorTree from "../DestructorTree";
import { visit_widget_expression } from "./visit_widget_expression";

export function render(
	parent_dom_element: () => HTMLElement,
	view: gui_definition_types.views.alan_api.Cviews__,
	client_state_context: api_client_state.Cnode,
	destructor: DestructorTree,
	view_root_dom_element: () => HTMLElement,
	client_view: api_client_state.Copen_views
): void {
	visit_widget_expression(view.properties.instance, client_state_context, destructor, {
		client_view: client_view,
		parent_dom_element: parent_dom_element,
		view_root_dom_element: view_root_dom_element,
		model_binding: undefined,
		entry_keys: [],
	});
}
